import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  @Input() msDelay = 0;

  constructor() { }
  delayed = true;

  ngOnInit() {
    // certain usages don't always show the loader when the msDelay is 0 and the setTimeout is used.
    if (this.msDelay > 0) {
      setTimeout(() => {
        this.delayed = false;
      }, this.msDelay);
    }
    else {
      this.delayed = false;
    }
  }
}
